import { getConfig } from "../config";
import { getUserManager } from "./userManager";

/**
 * Null when auth is disabled; otherwise the current Identity Server access token. oidc-client-ts owns the
 * token and renews it silently; an expired token with no renewal means the user must sign in again.
 */
export async function getAccessToken(): Promise<string | null> {
  if (!getConfig().AUTH_ENABLED) return null;
  const user = await getUserManager().getUser();
  if (!user || user.expired) throw new Error("No signed-in session. Please sign in.");
  return user.access_token;
}

export async function redirectToSignIn(): Promise<void> {
  if (!getConfig().AUTH_ENABLED) return;
  sessionStorage.setItem("preLoginUrl", window.location.pathname + window.location.search);
  await getUserManager().signinRedirect();
}
